import { buildShortagesTopEntitiesChart } from 'src/components/Layout/util/PrototypeShortagesWidgetUtils';
import { SHORTAGES_INDEX } from 'src/components/ShortageDisputes/components/ShortageSummary/constants';
import { Widget as WidgetType } from 'src/types/application/widgetTypes';
import ShortagesSummaryPageLayout from 'src/components/BeaconV2Components/ExperimentalLayout/Operations/Shortages/ShortageMetrics';
import { ShortagesProductGrid } from 'src/components/BeaconV2Components/ExperimentalLayout/Operations/Shortages/ShortagesProductGrid';

const buildShortagesSummaryWidgets = (
  { app, entity, weekIdField }: any,
  widgets: WidgetType[]
) => {
  // ------------------------- Assembling all widgets for page layout  -------------------------

  widgets.push({
    name: 'shortageMetrics',
    CustomComponent: ShortagesSummaryPageLayout,
    view: {}
  });

  widgets.push(
    buildShortagesTopEntitiesChart({
      app,
      entity,
      weekIdField,
      indexName: SHORTAGES_INDEX.shortageDisputes,
      metricType: 'updatedShortageAmountBeforeDispute'
    })
  );

  widgets.push({
    name: 'shortagesProductGrid',
    CustomComponent: ShortagesProductGrid,
    view: { container: { style: { marginBottom: '80px' } } }
  });
};

export default buildShortagesSummaryWidgets;
